import React from "react";
import { FooterNavBar } from "ComponentsUIV2/NavBars";
import useDefaultParams from "Services/useDefaultParams";
import routes from "Configs/routes";

import { pipe } from "Utils/functionalUtils";
import { observer, inject } from "mobx-react";
import { withRouter, useParams } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import { isMoscowSiteCode, isPiterSiteCode } from "Utils/siteConfig";

const FooterNavBarContainer = (props) => {
	const { siteCode, text } = props;
	const routeParams = useParams();
	const { regionUrl } = useDefaultParams(routeParams);

	let contactsURL = generateUrl(routes.Contacts.route, {
		regionUrl,
	});

	let reviewsURL = isMoscowSiteCode(siteCode)
		? "https://yandex.by/maps/org/moskva_on_line/1035796011/reviews/?ll=37.714127%2C55.710511&mode=search&sctx=ZAAAAAgBEAAaKAoSCZS%2Fe0eN30JAEXR%2BiuPA10tAEhIJN1DgnXx6tD8RRrbz%2FdR4qT8iBgABAgMEBSgKOABA5K0HSAFqAnVhnQHNzEw9oAEAqAEAvQFtC3scwgEFq%2Fzz7QOCAhN3d3cubW9za3Zhb25saW5lLnJ1igIAkgIAmgIMZGVza3RvcC1tYXBz&sll=37.714127%2C55.710511&sspn=0.302811%2C0.099436&tab=reviews&text=www.moskvaonline.ru&z=12"
		: "https://yandex.by/maps/org/101_internet/118153615879/reviews/?ll=37.746499%2C55.685574&z=13";

	let collaborationURL = generateUrl(routes.Partner.route, {
		regionUrl,
	});

	let personalURL = generateUrl(routes.PersonalData.route, {
		regionUrl,
	});

	let documentsURL = generateUrl(routes.PersonalData.route, {
		regionUrl,
		anchorUrl: "#processing",
	});

	return (
		<FooterNavBar
			aboutUsURL={""}
			paymentURL={""}
			blogURL={"/articles"}
			faqURL={""}
			contactsURL={contactsURL}
			careerURL={"/career"}
			reviewsURL={reviewsURL}
			collaborationURL={collaborationURL}
			siteCardURL={""}
			personalURL={personalURL}
			documentsURL={documentsURL}
			text={text}
			isPiter={isPiterSiteCode(siteCode)}
		/>
	);
};

export default pipe(observer, inject("ApplicationModel"), withRouter)(FooterNavBarContainer);
